import hljs from 'highlight.js/lib/core';

// languages supported by code parser step
import cpp from 'highlight.js/lib/languages/cpp';
import csharp from 'highlight.js/lib/languages/csharp';
import java from 'highlight.js/lib/languages/java';
import python from 'highlight.js/lib/languages/python';

hljs.registerLanguage('cpp', cpp);
hljs.registerLanguage('csharp', csharp);
hljs.registerLanguage('java', java);
hljs.registerLanguage('python', python);

export const detectLanguage = (code: string): string => {
  if (!code || code.trim().length === 0) return 'plaintext';

  try {
    const result = hljs.highlightAuto(code, ['cpp', 'csharp', 'java', 'python']);

    if (result.relevance > 2 && result.language) {
      return result.language;
    }

    return 'plaintext';
  } catch (error) {
    console.error('Language detection failed:', error);
    return 'plaintext';
  }
};
